<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">I would like to thank my dearest Mei; my mother, Rosemary; my brother Mark; and my mentor David Gilbey for their support.</p><br/>
<p style="text-indent:0em;">I also wish to acknowledge the Australian War Memorial (AWM), Canberra, as their official history of the Kokoda Campaign: ‘Australia in the War of 1939–45 Army Vol. V, South-West Pacific Area First Year, Kokoda to Wau’ (1962) provided the historical framework for <em>Against the Rising Sun</em>.</p><br/>
<p style="text-indent:0em;">The poem fragment reproduced in Chapter 12, published with the permission of the AWM, was written by Gunnie Sanders Waddell.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?271bed6b